import { useState } from 'react'
import { lumi } from '../lib/lumi'

export default function ForceEmail() {
  const [email, setEmail] = useState('augustin.lopez64@gmail.com')
  const [status, setStatus] = useState('')
  const [loading, setLoading] = useState(false)

  const sendEmail = async () => {
    setLoading(true)
    setStatus('')
    
    try {
      const result = await lumi.functions.invoke('forceEmailSend', {
        method: 'POST',
        body: JSON.stringify({ email })
      })
      
      console.log('Result:', result)
      setStatus(`✅ Email envoyé avec succès ! Code: ${result.code}`)
    } catch (error: any) {
      console.error('Error:', error)
      setStatus(`❌ Erreur: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-md mx-auto mt-20 bg-gray-800 p-8 rounded-lg">
        <h1 className="text-2xl font-bold mb-6">Force Email Send</h1>
        
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 mb-4 bg-gray-700 rounded text-white"
          placeholder="Email du client"
        />
        
        <button
          onClick={sendEmail}
          disabled={loading}
          className="w-full p-3 bg-blue-600 hover:bg-blue-700 rounded font-bold disabled:opacity-50"
        >
          {loading ? 'Envoi en cours...' : 'Envoyer Email'}
        </button>
        
        {status && (
          <div className="mt-4 p-4 bg-gray-700 rounded">
            {status}
          </div>
        )}
      </div>
    </div>
  )
}
